import { appGetState } from 'legacy/lut/store'

import { IDataProviderFilter, IDataProviderSort, Logic, Operator } from 'core-components/types'
import { checkCache, readFromCache, saveToCache } from 'core/classes/cache/Cache'
import StorageKeys from 'core/classes/cache/StorageKeys'
import { IReference } from 'core/classes/models/IReference'
import { CrudHelper } from 'core/types/helpers/CrudHelper'

export const fetchSalutations = async (): Promise<IReference[]> => {
  const needRefresh = checkCache(StorageKeys.salutations)
  if (needRefresh) {
    const crud = new CrudHelper(97, 'Dropdown')

    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'DropdownKey',
          value: 'Salutation',
          operator: Operator.EQUAL,
        },
        {
          field: 'AppId',
          value: appGetState().app.id,
          operator: Operator.EQUAL,
        },
      ],
    }

    const sort: IDataProviderSort = {
      field: 'SortOrder',
      dir: 'desc',
    }
    const response = (await crud.read(filter, sort, 1, 100, undefined, false)) || {}

    let result = []
    if (response && response['Data']) {
      result = response['Data'].map((element: any) => ({
        value: element.value,
        name: element.en,
      }))
    }
    saveToCache(StorageKeys.salutations, result, true)
    return result
  } else {
    return readFromCache(StorageKeys.salutations)
  }
}
